import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale } from 'chart.js';

// Register necessary components for Chart.js
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale);

const PieChart = ({ data }) => {
  const chartData = {
    labels: ['Customers', 'Service Providers'], // Labels for the pie chart
    datasets: [
      {
        data: data.map(item => item.value),  // Extract the values for the chart
        backgroundColor: ['#FF6384', '#36A2EB'],  // Set colors for each slice
        hoverBackgroundColor: ['#FF6384', '#36A2EB'],  // Hover colors
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',  // Position of the legend
        labels: {
          boxWidth: 20,  // Size of the colored box in the legend
          padding: 20,   // Spacing between the legend items
          usePointStyle: true, // Use circular points for the legend items
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.label}: ${tooltipItem.raw}`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '300px' }}>
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default PieChart;
